import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {action, observable, runInAction} from 'mobx';
import {injectIntl} from 'react-intl';
import DialogWrapper from '../../components/dialog/Dialog';
import './styles.scss';
import Close from "react-icons/lib/io/close";
import BaseButton from "../../components/button/BaseButton";
import {DeviceType, DialogTypes} from "../../constants/enums";
import CameraErrorComponent from "../../components/cameraErrorDialog/CameraErrorComponent";
import DeviceSelect from "./DeviceSelect";
import CamIcon from "../../assets/images/video-chat-cam";
import MicIcon from '../../assets/images/video-chat-mic';
import MutedCamIcon from "../../assets/images/video-chat-cam-muted";
import MutedMicIcon from '../../assets/images/video-chat-mic-muted';
import {getName, isStudent} from "../../utils/userUtility";
import MediaSelector from "../../components/mediaSelector";
import {isMobile} from "../../utils/screenUtility";
import SvgIcon from "@material-ui/core/SvgIcon";
import cameraIcon from "../../assets/images/camera-flip-white";
import IconButton from "@material-ui/core/IconButton";
import CircularLoaderInline from "../../components/circularLoader/CircularLoaderInline";

@injectIntl
@inject('dialogStore', 'videoChatStore')
@observer
class StartVideoDialog extends Component {
    @observable loading = false;
    @action videoRef = async (node) => {
        const {videoChatStore} = this.props;
        if (node) {
            this.loading = true;
            videoChatStore.previewVideoRef = node;
            try {
                await videoChatStore.prepareVideo();
            } finally {
                runInAction(() => {
                    this.loading = false;
                })
            }
        }
    }

    @action handleStart = async () => {
        const {dialogStore, videoChatStore} = this.props;
        dialogStore.closeDialog(DialogTypes.StartVideoChat);
        await videoChatStore.activateVideoChat();
    }

    @action handleRetry = () => {
        const {videoChatStore} = this.props;
        videoChatStore.streamError = false;
    }


    render() {
        const {onClose, open, intl: {formatMessage: translate}, videoChatStore} = this.props;
        const dialogProps = {
            classes: {root: 'video-chat-start-modal-root', paper: 'paper'},
            open: open,
            onExited: onClose,
            onClose: onClose
        };
        const {streamError} = videoChatStore;

        const showError = !!streamError;
        return (
            <DialogWrapper {...dialogProps}>
                {this.loading && <div className="video-chat-start-modal-loader"><CircularLoaderInline/></div>}
                {showError && <CameraErrorComponent onClick={this.handleRetry} onClose={onClose}/>}
                {!showError && <div className={`video-chat-start-modal ${videoChatStore.noFlipLocalVideo ? 'no-flip' : ''}`}>
                    <div className={"video-chat-top-overlay"}>
                        <button className="video-chat-start-modal-close" onClick={onClose}>
                            <Close/>
                        </button>
                    </div>

                    <MediaSelector devices={[DeviceType.Mobile]}>
                        <IconButton classes={{root: 'camera-switch-btn'}} onClick={videoChatStore.switchVideoDevice}>
                            <SvgIcon viewBox="0 0 24 24">{cameraIcon}</SvgIcon>
                        </IconButton>
                    </MediaSelector>


                    <div className="video-chat-start-modal-video">
                        {videoChatStore.videoMuted &&
                        <div className="video-chat-start-modal-no-video">
                            <h1>{getName()}</h1>
                        </div>
                        }
                        <video ref={this.videoRef} className={`remote-view ${videoChatStore.localMirroringActive ? 'mirror' : ''}`} autoPlay playsInline muted/>
                    </div>

                    <div className={"video-chat-start-modal-buttons"}>
                        <div className={"video-chat-device-selection"}>
                            <DeviceSelect icon={MicIcon} iconMuted={MutedMicIcon} muted={videoChatStore.audioMuted}
                                          onClickMute={videoChatStore.toggleMuteAudio} titleKey='video.chat.select.audio'
                                          deviceList={videoChatStore.audioDevices} onDeviceSet={videoChatStore.setAudioDevice}
                                          compact={isMobile()}/>
                            <DeviceSelect icon={CamIcon} iconMuted={MutedCamIcon} muted={videoChatStore.videoMuted}
                                          onClickMute={videoChatStore.toggleMuteVideo} titleKey='video.chat.select.video'
                                          deviceList={videoChatStore.videoDevices} onDeviceSet={videoChatStore.setVideoDevice}
                                          compact={isMobile()}
                                          withMirror={true} toggleLocalMirroring={videoChatStore.toggleLocalMirroring}
                                          localMirroringActive={videoChatStore.localMirroringActive} />
                        </div>

                        <BaseButton
                            disabled={this.loading}
                            data-testid={"launch-button"}
                            label={translate({id: isStudent() ? 'video.chat.start.student' : 'video.chat.start.teacher'})}
                            onClick={this.handleStart}
                        />
                    </div>
                </div>}
            </DialogWrapper>
        );
    }
}

export default StartVideoDialog;
